import { useState, useEffect } from 'react';

const getAspectRatio = (width: number) => {
  if (width > 1024) return 2; // Desktop (16:9)
  if (width > 768) return 1.5; // Tablet (4:3)
  if (width > 600) return 1; // Tablet (4:3)
  return 0.75; // Mobile
};

const useAspectRatio = () => {
  const [aspectRatio, setAspectRatio] = useState<number>(() => {
    // Default aspect ratio for SSR (assumed mobile)
    return typeof window !== 'undefined'
      ? getAspectRatio(window.innerWidth)
      : 0.7;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return; // Skip effect in SSR

    const handleResize = () =>
      setAspectRatio(getAspectRatio(window.innerWidth));

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return aspectRatio;
};

export default useAspectRatio;
